module.exports = __webpack_public_path__ + "static/img/B环视主机.2adb2bf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/products/type1-1/fit/B环视主机.png
// module id = dUYF
// module chunks = 0